export default __webpack_public_path__ + "static/media/QSGA_Icon_Navigation_Menu.1c746735.png";